import * as React from "react";
function SvgArrowDown(props, svgRef) {
  return <svg viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M21.1716 0H12H2.82843C1.04662 0 0.154281 2.15428 1.41421 3.41421L10.5858 12.5858C11.3668 13.3668 12.6332 13.3668 13.4142 12.5858L22.5858 3.41421C23.8457 2.15428 22.9534 0 21.1716 0Z" style={{
      fill: "var(--svg-color, #000)"
    }} /></svg>;
}
const ForwardRef = React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "src/openspace/assets/svg/icons/arrow-down.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/openspace/assets/svg/icons/arrow-down_0.5x.svg",
  "1x": __webpack_public_path__ + "src/openspace/assets/svg/icons/arrow-down_1x.svg",
  "2x": __webpack_public_path__ + "src/openspace/assets/svg/icons/arrow-down_2x.svg",
  "3x": __webpack_public_path__ + "src/openspace/assets/svg/icons/arrow-down_3x.svg",
  "4x": __webpack_public_path__ + "src/openspace/assets/svg/icons/arrow-down_4x.svg"
};
export { ForwardRef as ReactComponent };